import { useTranslation } from 'react-i18next';

import { useChecklistStore, ViewMode } from '@/apps/Checklist/stores/useChecklistStore';
import { useAuthStore } from '@/common/stores/useAuthStore';

interface ChecklistConfigProps {
  widgetId: string;
  onClose: () => void;
}

export default function ChecklistConfig({ onClose }: ChecklistConfigProps) {
  const { t } = useTranslation();
  const VIEW_OPTIONS: { mode: ViewMode; labelKey: string; descKey: string }[] = [
    { mode: 'daily', labelKey: 'checklist.viewDaily', descKey: 'checklist.viewDailyDesc' },
    { mode: 'weekly', labelKey: 'checklist.viewWeekly', descKey: 'checklist.viewWeeklyDesc' },
    { mode: 'monthly', labelKey: 'checklist.viewMonthly', descKey: 'checklist.viewMonthlyDesc' },
  ];
  const { viewMode, setViewMode } = useChecklistStore();
  const { user } = useAuthStore();

  const handleModeChange = (newMode: ViewMode) => {
    setViewMode(newMode, user?.id);
    onClose();
  };

  return (
    <div className="p-4 flex flex-col gap-4">
      <h3 className="text-lg font-semibold text-gray-800">{t('checklist.viewSettings')}</h3>
      <div className="flex flex-col gap-3">
        {VIEW_OPTIONS.map(({ mode, labelKey, descKey }) => (
          <button
            key={mode}
            className={`px-6 py-3 rounded-lg transition-all duration-200 ${
              viewMode === mode
                ? 'bg-black text-white shadow-lg'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
            onClick={() => handleModeChange(mode)}
          >
            <div className="text-left">
              <div className="font-medium">{t(labelKey)}</div>
              <div className="text-xs opacity-80">{t(descKey)}</div>
            </div>
          </button>
        ))}
      </div>
      <button
        className="mt-2 px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
        onClick={onClose}
      >
        {t('common.cancel')}
      </button>
    </div>
  );
}
